"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRoleParsedResponse = void 0;
function transformRoleParsedResponse(role) {
    return {
        id: role.id,
        role: role.role,
        systemId: role.systemid,
        userId: role.userid,
        accountId: role.accountid.toString(),
        createdAt: new Date(role.created_at),
        links: role.links,
    };
}
exports.transformRoleParsedResponse = transformRoleParsedResponse;
//# sourceMappingURL=Role.js.map